import React from 'react'
import { isNil } from 'ramda'
import PropTypes from 'prop-types'

const PanelFilter = (props) => {
  const { leftContent, rightContent } = props
  return (
    <div className="w-full md:flex md:justify-between my-5 space-y-5">
      <div className="space-x-5 space-x-reverse space-y-5">{leftContent}</div>

      {isNil(rightContent) ? null : (
        <div className="flex items-center">{rightContent}</div>
      )}
    </div>
  )
}

PanelFilter.propTypes = {
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
}

export default PanelFilter
